module.exports = __webpack_public_path__ + "static/media/3.9d18710a.mp4";